<template>
  <div class="tech-roadmap-container">
    <div class="top-bg">
      <div class="title">
        <div>DO </div>
        <div>Roadmap</div>
      </div>
      <!-- <div class="sub-title">What we did about the technical route?</div>
      <div class="content-text">We're proud of what we've accomplished with our community so far — and look forward to tackling challenges and building more with a whole new generation of participants.</div> -->
    </div>

    <div class="date-container">
      <div class="date-component" v-for="item of dateList" :key="item.id">
        <div class="date-quarter"><p>{{item.quarter}}</p></div>
        <div class="date-month">{{item.month}}</div>
        <div class="blue-divide"></div>
        <div class="date-desc"><span>{{ item.tit }}</span>{{item.desc}}</div>
        <div class="date-desc"><span>{{ item.tit1 }}</span>{{item.desc1}}</div>
        <div class="date-desc"><span>{{ item.tit2 }}</span>{{item.desc2}}</div>
        <div class="date-desc"><span>{{ item.tit3 }}</span>{{item.desc3}}</div>
        <div class="date-desc"><span>{{ item.tit4 }}</span>{{item.desc4}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      dateList: [
        {
          id: 1,
          quarter: "Q1",
          month: "2025-Q1",
          tit: "DeFi Ecosystem Expansion:",
          tit1: "Developer Support:",
          tit2: "MEME Ecosystem Expansion:",
          tit3: "Grant Program:",
          tit4: "",
          desc: " Enhance financial infrastructure by introducing new projects such as lending platforms, trading platforms, and stablecoins.",
          desc1:
            " Provide more developer tools and resources, launch or improve SDKs to attract developers to join.",
          desc2:
            " Promote the adoption of MEME tools and protocols to increase user engagement.",
          desc3:
            " Further promote the existing grant program to support the development of more ecosystem projects.",
          desc4: "",
        },
        {
          id: 2,
          quarter: "Q2",
          month: "2025-Q2",
          tit: "User Education:",
          tit1: "Cross-Chain Solutions:",
          tit2: "Security and Stability:",
          tit3: "NFT Market Expansion:",
          tit4: "Ecosystem Collaboration:",
          desc: " Launch more educational content to help new users quickly adapt to the DO ecosystem.",
          desc1:
            "Improve interoperability with other blockchains and enrich cross-chain experiences.",
          desc2:
            "Optimize the network infrastructure to enhance performance, security, and scalability.",
          desc3:
            "Support more NFT projects, optimize platforms, and expand use cases for art, collectibles, and utility NFTs.",
          desc4:
            "Partner with other promising ecosystems for joint events to achieve traffic sharing.",
        },
        {
          id: 3,
          quarter: "Q3",
          month: "2025-Q3",
          tit: "AI Agent:",
          tit1: "Stablecoin Ecosystem:",
          tit2: "Market Promotion:",
          tit3: "Technical Optimization:",
          tit4: "Infrastructure Integration:",
          desc: " Launch or support AI applications to leverage DO's speed advantages.",
          desc1:
            "Strengthen integration with traditional finance and expand stablecoin use cases.",
          desc2:
            "Attract more users and developers through marketing and partnerships to promote DO.",
          desc3:
            "Improve network performance, reduce transaction fees, and increase transaction speed.",
          desc4:
            "Integrate more core features into wallets, browsers, and other foundational tools to improve usability.",
        },
        {
          id: 4,
          quarter: "Q4",
          month: "2025-Q4",
          tit: "DePin Expansion:",
          tit1: "RWA (Real-World Assets):",
          tit2: "AI Ecosystem Advancement:",
          tit3: "Community Governance and Participation:",
          tit4: "Ecosystem Diversification:",
          desc: " Develop and promote decentralized physical infrastructure networks (DePin) to connect the physical world with the DO ecosystem.",
          desc1:
            " Launch platforms that support real-world assets, integrating traditional assets such as real estate and artwork into the DO ecosystem.",
          desc2:
            " Further integrate AI technology to enhance its applications in the DO ecosystem, such as automating smart contracts, data processing, and optimizing user experiences.",
          desc3:
            " Increase community engagement through DAO or similar mechanisms, giving the community a greater voice",
          desc4:
            " Introduce more innovative applications, including but not limited to blockchain solutions in health, education, and logistics, to expand DO's use cases",
        },
        // {
        //   id: 4,
        //   quarter: "Q1",
        //   month: "Mar 2022",
        //   desc: "Combine related modules of the DO Network.",
        // },
        // {
        //   id: 5,
        //   quarter: "Q2",
        //   month: "Apr 2022",
        //   desc: "Start the capital operation of the DO network.",
        // },
        // {
        //   id: 6,
        //   quarter: "Q2",
        //   month: "May 2022",
        //   desc: "Start the DO Network test network.",
        // },
        // {
        //   id: 7,
        //   quarter: "Q2",
        //   month: "June 2022",
        //   desc: "Enter the Test net Ark competition.",
        // },
        // {
        //   id: 8,
        //   quarter: "Q3",
        //   month: "Aug 2022",
        //   desc: "Launch the main network officially.",
        // },
        // {
        //   id: 9,
        //   quarter: "Q3",
        //   month: "Sep 2022",
        //   desc: "Launch the DAO Ecological Development Fund.",
        // },
        // {
        //   id: 10,
        //   quarter: "Q4",
        //   month: "Oct 2022",
        //   desc: "Launch the native autonomy voting for the DO network.",
        // },
        // {
        //   id: 11,
        //   quarter: "Q4",
        //   month: "Dec 2022",
        //   desc: "Start the autonomous development of open decentralization of the DAO protocol.",
        // },
      ],
    }
  }
}
</script>

<style lang="less" scoped>
  .tech-roadmap-container{
    .top-bg{
      padding: 230px 51px 0;
      // height: 761px;
      text-align: center;
      background-image: url("../../../assets/m/techroadmap.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .title{
        height:165px;
        font-size: 64px;
        font-family: Poppins-Black, Poppins;
        font-weight: 900;
        color: #000000;
        line-height: 83px;
        -webkit-background-clip: text;
      }
      .sub-title{
        margin-top:20px;
        font-size: 30px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #000000;
        line-height: 35px;
        -webkit-background-clip: text;
      }
      .content-text{
        margin-top:20px;
        padding: 0 20px;
        height: 171px;
        font-size: 26px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #61666B;
        line-height: 43px;
        -webkit-background-clip: text;
      }
    }
    .date-container{
     margin-top: 20px;
      &:nth-last-child(1){
        // margin-bottom: 100px;
      }
      .date-component{
        // margin: 0 20px;
        padding: 0 53px;
        margin: 0 47px 50px;
        // padding: 0 53px;
        border: 2px solid #FFFFFF;
        border-radius: 30px;
        box-shadow: 0px 22px 51px 1px rgba(46,87,192,0.05);
        background:rgba(251, 251, 251, 0.3);
        //  border: 1px solid red;
         padding-bottom: 60px;
        .date-quarter{
          padding-top:53px;
          p{
            width: 89px;
            height: 90px;
            line-height: 90px;
            font-size: 60px;
            font-family: Poppins-ExtraBold, Poppins;
            font-weight: 800;
            color: rgba(52, 51, 61, 0.08);
            -webkit-background-clip: text;
          }
        }
        .date-month{
          margin-top:14px;
          height: 90px;
          line-height: 90px;
          font-size: 60px;
          font-family: Poppins-ExtraBold, Poppins;
          font-weight: 800;
          color: #34333D;
          -webkit-background-clip: text;
        }
        .blue-divide{
          margin-top:50px;
          width: 60px;
          height: 6px;
          background: #4573E7;
        }
        .date-desc{
          margin-top:50px;
         
          font-size: 26px;
          font-family: Poppins-Regular, Poppins;
          font-weight: 400;
          color: #61666B;
          line-height: 39px;
          white-space: pre-line;
          -webkit-background-clip: text;
          span{
            color: #000000;
            font-weight: 800;
          }
        }
      }
    }
  }
</style>